import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {Record, Map, Set, List} from 'immutable';
import DashMetricsActions from 'actions/dashboard/DashMetricsActions';

export class MetricKey extends Record({
  metric: undefined,
  teamIds: Set(),
  direction: undefined,
}) {
  constructor(metric, teamIds, direction) {
    super({
      metric,
      teamIds: Set(teamIds),
      direction,
    });
  }
}

@immutableStore
class DashMetricsStore {
  constructor() {
    this.state = Record({
      user: Map(),
      team: Map(),
      loadingCallSearch: false,
      topicIds: List(),
    })();
    this.bindActions(DashMetricsActions);
  }

  userMetricSuccess([{teamIds, metricType, direction}, metrics]) {
    const key = new MetricKey(metricType, teamIds, direction);
    this.setState({
      user: this.state.user.set(key, metrics),
    });
  }

  userMetricError(err) {
    console.error(err);
  }

  teamMetricSuccess([{teamIds, metricType, direction}, metrics]) {
    const key = new MetricKey(metricType, teamIds, direction);
    this.setState({
      team: this.state.team.set(key, metrics),
    });
  }

  teamMetricError(err) {
    console.error(err);
  }

  callsForMetric() {
    this.setState({
      loadingCallSearch: true,
    });
  }

  callsForMetricSuccess() {
    this.setState({
      loadingCallSearch: false,
    });
  }

  callsForMetricError(err) {
    console.error(err);
    this.setState({
      loadingCallSearch: false,
    });
  }

  topicIdsForTriggerId(topicIds) {
    this.setState({
      topicIds: List(),
    });
  }

  topicIdsForTriggerIdSuccess(topics) {
    this.setState({
      topicIds: topics.map(t => t.id),
    });
  }

  topicIdsForTriggerIdError(e) {
    console.warn(e);

    this.setState({
      topicIds: List(),
    });
  }

  clearTopicIds() {
    this.setState({
      topicIds: List(),
    });
  }
}

export default alt.createStore(DashMetricsStore);
